<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 26.666H13.3333C13.687 26.666 14.0261 26.8065 14.2761 27.0565C14.5262 27.3066 14.6667
      27.6457 14.6667 27.9993C14.6667 28.353 14.5262 28.6921 14.2761 28.9422C14.0261 29.1922 13.687
      29.3327 13.3333 29.3327H8C6.93913 29.3327 5.92172 28.9113 5.17157 28.1611C4.42143 27.411 4
      26.3935 4 25.3327V6.66602C4 5.60515 4.42143 4.58773 5.17157 3.83759C5.92172 3.08744 6.93913
      2.66602 8 2.66602H16.08L16.5067 2.81268C16.5465 2.80703 16.5869 2.80703 16.6267
      2.81268C16.7638 2.87679 16.8898 2.9623 17 3.06602L25 11.066C25.1037 11.1762 25.1892 11.3023
      25.2533 11.4393V11.5593C25.2926 11.6762 25.3194 11.7969 25.3333
      11.9193V11.9993V13.3327C25.3333 13.6863 25.1929 14.0254 24.9428 14.2755C24.6928 14.5255
      24.3536 14.666 24 14.666C23.6464 14.666 23.3072 14.5255 23.0572 14.2755C22.8071 14.0254
      22.6667 13.6863 22.6667 13.3327H18.6667C17.6058 13.3327 16.5884 12.9113 15.8382
      12.1611C15.0881 11.411 14.6667 10.3935 14.6667 9.33268V5.33268H8C7.64638 5.33268 7.30724
      5.47316 7.05719 5.72321C6.80714 5.97326 6.66667 6.31239 6.66667 6.66602V25.3327C6.66667
      25.6863 6.80714 26.0254 7.05719 26.2755C7.30724 26.5255 7.64638 26.666 8 26.666ZM20.7867
      10.666L17.3333 7.21268V9.33268C17.3333 9.6863 17.4738 10.0254 17.7239 10.2755C17.9739 10.5255
      18.313 10.666 18.6667 10.666H20.7867ZM19.2504 19.9994C19.3583 19.8616 19.4757 19.7288 19.6025
      19.6019C21.2948 17.9096 24.0385 17.9096 25.7308 19.6019C26.1213 19.9924 26.7545 19.9924 27.145
      19.6019C27.5355 19.2114 27.5355 18.5782 27.145 18.1877C24.6717 15.7144 20.6616 15.7144 18.1883
      18.1877C17.6472 18.7288 17.2245 19.3434 16.9202 19.9994H15.6667C15.1144 19.9994 14.6667
      20.4471 14.6667 20.9994C14.6667 21.5517 15.1144 21.9994 15.6667 21.9994H16.3683C16.3217
      22.4425 16.3217 22.8896 16.3683 23.3327H15.6667C15.1144 23.3327 14.6667 23.7804 14.6667
      24.3327C14.6667 24.885 15.1144 25.3327 15.6667 25.3327H16.9202C17.2246 25.9887 17.6473 26.6033
      18.1883 27.1444C20.6616 29.6177 24.6717 29.6177 27.145 27.1444C27.5355 26.7538 27.5355 26.1207
      27.145 25.7301C26.7545 25.3396 26.1213 25.3396 25.7308 25.7301C24.0385 27.4224 21.2948 27.4224
      19.6025 25.7301C19.4757 25.6033 19.3583 25.4705 19.2505 25.3327H21.6667C22.219 25.3327 22.6667
      24.885 22.6667 24.3327C22.6667 23.7804 22.219 23.3327 21.6667 23.3327H18.3846C18.3162 22.8911
      18.3162 22.441 18.3846 21.9994H21.6667C22.219 21.9994 22.6667 21.5517 22.6667 20.9994C22.6667
      20.4471 22.219 19.9994 21.6667 19.9994H19.2504Z"
      fill="currentColor"
    />
  </svg>
</template>
